import WebUtils from './webUtils';
import _some from 'lodash/some';
import _values from 'lodash/values';
import _includes from 'lodash/includes';
import envUtils from './envUtils';

const utils = {
  isDevEnv: () => process.env.NODE_ENV === 'development',
  isDemoEnv: () => process.env.NODE_ENV === 'demo',
  isMakeupARSite: () => window.location.host.includes('makeupar'),
  isJa: () => {
    return window.location.href.indexOf('ja') !== -1 || window.location.href.indexOf('ja') !== -1;
  },

  isTw: () => {
    return window.location.href.indexOf('zh_tw') !== -1 || window.location.href.indexOf('zh-tw') !== -1;
  },
  isPictureTagSupported: () => !!window.HTMLPictureElement,
  isWebPSupported: () => {
    const elem = document.createElement('canvas');
    if (!!(elem.getContext && elem.getContext('2d'))) {
      // was able or not to get WebP representation
      return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }

    // very old browser like IE 8, canvas not supported
    return false;
  },
  isMobile: () => window.innerWidth <= 600,
  ytLink: () => {
    if (WebUtils.isJa()) return 'https://www.youtube.com/channel/UCvb76vuw_lla1ELqb-WaUnA';
    // if (WebUtils.isBusiness())
    return 'https://www.youtube.com/channel/UC7GeoFYO277cNdRa_k8TWug';
    // return 'https://www.youtube.com/channel/UCExTYT6XYEt_bT6qs7m-X0A';
  },
  fbLink: () => {
    if (WebUtils.isTw()) return 'https://www.facebook.com/YouCamApps.tw';
    if (WebUtils.isJa()) return 'https://www.facebook.com/perfectcorp.jp';
    return 'https://www.facebook.com/youcamapps/';
  },
  jobLink: () => {
    if (WebUtils.isTw()) return 'https://www.104.com.tw/company/1a2x6bjgwu';
    return 'https://www.linkedin.com/company/perfect-corp';
  },
  igLink: () => {
    if (WebUtils.isTw()) return 'https://www.instagram.com/youcamapps.tw/';
    if (WebUtils.isJa()) return 'https://www.instagram.com/youcammake/';
    return 'https://instagram.com/youcamapps/';
  },
  twitterLink: () => {
    if (WebUtils.isJa()) return 'https://twitter.com/youcammake';
    return 'https://twitter.com/youcamapps';
  },
  openInNewTab: (href) => {
    Object.assign(document.createElement('a'), {
      target: '_blank',
      href: href,
    }).click();
  },
  isMsrFormPreview: () => (envUtils.isStage || envUtils.isDemo) && _some(_values(window.location.ancestorOrigins), (origin) => _includes(origin, 'eperfect') || _includes(origin, 'pfc-test-dt')),
};

export default utils;
